<template>
  <div class="wrapper">
    <div class="card">
      <div class="item">
        <span class="title_tag">商品名称:</span>
        <span class="title">{{ orderpay.gname }}</span>
      </div>
      <div class="item">
        <span class="title_tag">券码:</span>
        <span class="title">{{ orderpay.code }}</span>
      </div>
      <div class="item">
        <span class="title_tag">订单号:</span>
        <span class="title">{{ orderpay.orderno }}</span>
      </div>
    </div>
    <div class="btn">
      <Button type="warning" size="mini" @click="check()">核验</Button>
    </div>
  </div>
</template>

<script>
import { isWeiXin, checklogin } from '@/libs/utils'
import { h5checkin } from '@/libs/api.js'
import { NumberKeyboard, Field, Form, Button, CouponCell, CouponList, Popup } from 'vant'
import { getLastRouter, goBack, setStorage, islogin, userinfo, getStorage } from '@/libs/utils'
export default {
  name: 'index',
  data() {
    return {
      show: false,
      loading: false,
      money: '',
      stid: '',
      detail: {},
      showList: false,
      showOrder: false,
      orderdetail: {},
      shipment: {},
      coupons: [],
      chosenCoupon: 0,
      orderpay: {},
    }
  },
  components: {
    NumberKeyboard,
    Field,
    Form,
    Button,
    CouponCell,
    CouponList,
    Popup,
  },
  methods: {
    check() {
      h5checkin({
        orderid: this.orderpay.orderid,
        code: this.orderpay.code,
      }).then((res) => {
        if (res.status * 1 == 200) {
          this.$dialog.alert({
            message: res.message,
          })
        }
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.isweixin = isWeiXin()
      let orderpay = window.localStorage.getItem('orderpay')
      this.orderpay = JSON.parse(orderpay)
    })
  },
}
</script>

<style scoped lang="less">
.wrapper {
  background: #ffffff;
  /*background: red;*/
  position: absolute;
  min-height: 100%;
  width: 100%;
  .card {
    box-sizing: border-box;
    padding: 0.8rem;
    .item {
      font-size: 1rem;
      padding: 0.2rem 0.1rem;
      display: flex;
      position: relative;
      align-items: center;
      font-weight: 400;
      .title_tag {
        width: 4.5rem;
        flex-shrink: 0;
        text-align: right;
        border-right: 1px solid white;
        font-size: 0.8rem;
        color: #9b9b9b;
      }
      .title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: initial;
        color: #3b3b3b;
        text-align: right;
        position: absolute;
        font-size: 0.8rem;
        left: 4.8rem;
        right: 0.3rem;
      }
    }
  }
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      width: 6rem;
      height: 2rem;
      font-size: 1rem;
    }
  }
}
</style>
